import React from 'react';
import styled from 'styled-components';
import {reduxForm, FormSection} from 'redux-form'
import {
    DOCUMENTATION_UPDATE_SECTION,
    FORM_ATTACHMENTS_SECTION,
    FORM_MESSAGES_SECTION,
    FORM_PROBLEM_DESCRIPTION_SECTION,
    FORM_TICKET_SECTION,
    FORM_VEHICLE_DETAIL_SECTION,
} from '../../../../constants/formConstants';
import TicketSection from './sections/ticket/TicketSection';
import AttachmentSection from './sections/attachments/AttachmentSection';
import TicketStatusHistory from '../../../common/TicketStatusHistory';
import VehicleDetailSection from './sections/vehicleDetail/VehicleDetailSection';
import MessagesSection from './sections/messagesSection/MessagesSection';
import RenderSyncErrors from '../../../common/RenderSyncErrors';
import {scrollContentWrapperToTop} from '../../../../utils/utils';
import SubmitButtons from './sections/SubmitButtons';
import formMessages from '../../../../intl/afterSales/formMessages';
import {aseFieldLabelMapping} from '../../../../constants/aseFieldLabelMapping';
import PropTypes from 'prop-types';
import {moduleRoles} from '../../../../utils/roles';
import ProblemDescriptionEasyBasketSection from "./sections/problemDescription/ProblemDescriptionEasyBasketSection";
import EasyBasketDocumentationUpdateSection from "./sections/documentationUpdate/EasyBasketDocumentationUpdateSection";

const StyledDiv = styled.div`
  border-radius: 10px;
`;

const EasyBasketMasterForm = (props) => {
    const {form, userRights, readOnly, handleSubmit, reqFields, editMode, userRoles} = props;

    return (
        <StyledDiv className="border border-dark p-4 bg-light">
            <RenderSyncErrors form={form} intlMessages={formMessages} mapping={aseFieldLabelMapping}/>
            <FormSection name={FORM_TICKET_SECTION}>
                <TicketSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <FormSection name={FORM_VEHICLE_DETAIL_SECTION}>
                <VehicleDetailSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <FormSection name={FORM_PROBLEM_DESCRIPTION_SECTION}>
                <ProblemDescriptionEasyBasketSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <FormSection name={FORM_MESSAGES_SECTION}>
                <MessagesSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            {userRights.canViewDocumentationUpdateSection && moduleRoles.isSGEditorAse(userRoles) && <FormSection name={DOCUMENTATION_UPDATE_SECTION}>
                <EasyBasketDocumentationUpdateSection form={form} userRights={userRights} reqFields={reqFields}
                                              readOnly={readOnly}/>
            </FormSection>}
            <FormSection name={FORM_ATTACHMENTS_SECTION}>
                <AttachmentSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <TicketStatusHistory form={form}/>
            <SubmitButtons form={form} onSubmit={handleSubmit} onSubmitFail={scrollContentWrapperToTop}
                           userRights={userRights} readOnly={readOnly} editMode={editMode}/>
        </StyledDiv>
    )
}

EasyBasketMasterForm.propTypes = {
    form: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func,
    readOnly: PropTypes.bool,
    userRights: PropTypes.object.isRequired,
    reqFields: PropTypes.array.isRequired,
};

export default reduxForm({})(EasyBasketMasterForm);
